import { useRouteParams } from '@vueuse/router';

export const useRouteRelatienummer = () =>
  useRouteParams('relatienummer', '', {
    transform: (value) => Number.parseInt(value, 10),
  });
